import axios, { AxiosResponse } from "axios";
import { ENDPOINTS } from "@/api/routing";

import {
  Data,
  FileResponseType,
  GenericNotification,
  IContact,
  ICountry,
  IScreenShot,
  ITimeZone,
  MultiFileResponseType,
  SpecialHeader,
  VisitorResponseType,
  VisitorType,
} from "@/types/all.types";
import { getAxiosConfig, getHeaders } from "./axiosConfig";
import { IPricing, IPlanDetails } from "@/types/billing.types";
import { IAuthorBlogs } from "@/components/page-modules/blog/data/blog.types";

const commonRequest = {
  visitorInitialize: async (data: VisitorType): Promise<VisitorResponseType> => {
    const { headers } = getHeaders();
    return getAxiosConfig()
      .post(ENDPOINTS.VISITOR_INITIALIZE(), data, { headers })
      .then((res: AxiosResponse) => res);
  },

  insertHotjarId: async (analytic_id: string) => {
    const { headers } = getHeaders();
    const res = await getAxiosConfig().put(
      ENDPOINTS.PUT_INSERT_HOTJR_ID(),
      { analytic_id },
      { headers },
    );
    return res;
  },
};

const common = {
  getPlanDetails: async (uuid: string) => {
    const res = await getAxiosConfig().get<IPlanDetails>(ENDPOINTS.GET_PLAN_DETAILS(uuid));
    return res.data;
  },
  getYoutubeId: async (params: any) => {
    const res = await axios.get(
      `https://content.googleapis.com/youtube/v3/videos?id=${params}&part=snippet%2CcontentDetails%2Cstatistics&key=AIzaSyCy9MKMDVzBez8ctPLVkqWi7wlhFCgTge4`,
    );
    return res.data;
  },
  getCountry: async () => {
    const res = await axios.get<ICountry>(ENDPOINTS.GET_COUNTRIES());
    return res.data;
  },

  getNotification: async () => {
    const res = await getAxiosConfig().get<Data<GenericNotification>>(ENDPOINTS.GET_NOTIFICATION());
    return res.data;
  },
  postNotification: async (id: string) => {
    const res = await getAxiosConfig().post(ENDPOINTS.POST_NOTIFICATION(id));
    return res.data;
  },
  getTimeZone: async () => {
    const res = await axios.get<ITimeZone>(ENDPOINTS.GET_TIMEZONE());
    return res.data;
  },
  postContact: async (params: any) => {
    const res = await axios.post<IContact>(ENDPOINTS.POST_CONTACT(), params);
    return res.data;
  },
  postScreenshot: async (params: { source: string }) => {
    const res = await getAxiosConfig().post<IScreenShot>(ENDPOINTS.POST_SCREENSHOT(), params);

    return res.data;
  },
  postUploadFile: async (params: Record<string, any>) => {
    const res = await getAxiosConfig().post<Data<FileResponseType>>(
      ENDPOINTS.POST_UPLOAD_FILE(),
      params,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return res.data;
  },
  putUpdateFileMetadata: async (id: number, data: Record<string, any>) => {
    const res = await getAxiosConfig().put<Data<FileResponseType>>(
      ENDPOINTS.PUT_UPLOAD_FILE_METADATA(id),
      {
        metadata: data,
      },
    );
    return res.data;
  },
  deleteUploadFile: async (id: number) => {
    const res = await getAxiosConfig().delete(ENDPOINTS.DELETE_UPLOAD_FILE(id));
    return res.data;
  },
  postUploadMultiFiles: async (params: FormData) => {
    const res = await getAxiosConfig().post<Data<MultiFileResponseType>>(
      ENDPOINTS.POST_UPLOAD_MULTI_FILE(),
      params,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );

    return res.data;
  },
  getAuthorBlogs: async (
    params: { sort: string; perPage: number; direction: string; page?: number | null },
    id: number,
  ) => {
    const res = await getAxiosConfig().get<IAuthorBlogs>(ENDPOINTS.GET_AUTHOR_INFO(id), {
      params: {
        perPage: params.perPage,
        sort: params.sort,
        page: params.page,
        direction: params.direction,
      },
    });
    return res.data;
  },
};

const pages = {
  getPricing: async () => {
    const res = await getAxiosConfig().get<IPricing>(ENDPOINTS.GET_PRICING());
    return res.data;
  },
  getPricingForSSR: async (header: Record<"headers", SpecialHeader>) => {
    const res = await getAxiosConfig(header).get<IPricing>(ENDPOINTS.GET_PRICING());
    return res.data;
  },
};

const email = {
  postChangeInvoiceEmail: async (params: { email: string }) => {
    const res = await getAxiosConfig().post(ENDPOINTS.POST_CHANGE_INVOICE_EMAIL(), params);
    return res.data;
  },
};

export { commonRequest, common, pages, email };
